"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Close = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  width: 1170,
  maxWidth: '100%',
  minHeight: 500,
  margin: '0 auto',
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(10, 6),
    maxWidth: `calc(100% - ${theme.spacing(12)})`
  },
  // temporary before AGRO fix in npm
  [theme.breakpoints.down('sm')]: {
    [`& .${_mui.grid2Classes.root}.${_mui.grid2Classes.root}`]: {
      borderRadius: theme.spacing(0)
    }
  }
}));
const Close = exports.Close = (0, _mui.styled)(_icons.Clear)(({
  theme
}) => ({
  position: 'absolute',
  top: theme.spacing(3),
  right: theme.spacing(3),
  cursor: 'pointer',
  [theme.breakpoints.up('sm')]: {
    top: theme.spacing(16),
    right: theme.spacing(12)
  }
}));